import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { VIEWS_MAP } from '../../../router/constants';
import { useStore } from '../../../store';
import { useGetLimitsTier } from '../api/useGetLimitsTier';
import { useRequestLimitsTierUpgrade } from '../api/useRequestUpgrade';
import { useUploadGenericFile } from '../../../hooks/utilities/useUploadGenericFile';
import { GENERIC_FILE_UPLOAD_TYPES } from '../../../types';
import {
  reportActOnLimitsIncreaseBottomSheet,
  reportActOnLimitsScreen,
  reportViewLimitsScreen,
} from '../limits.analytics';
import { LimitSuccesModalTypeProps } from '../components/LimitsResultModal';

export const useLimitsPageHook = () => {
  const navigate = useNavigate();
  const { getPersonalAccount, user } = useStore((state) => state);
  const { accountExternalId } = getPersonalAccount();
  const [openLimitsModal, setOpenLimitsModal] = React.useState(false);
  const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
  const [modalType, setModalType] = React.useState<LimitSuccesModalTypeProps>({
    title: '',
    content: '',
    buttonText: '',
    success: false,
  });
  const { t } = useTranslation('limitsEN');
  const { mutateAsync: postUploadSnapShot } = useUploadGenericFile();

  const { customerId } = user;
  const { data: teirData, refetch } = useGetLimitsTier({ customerId, accountExternalId });
  const { mutate, isLoading: requestLoading, isSuccess, isError } = useRequestLimitsTierUpgrade();
  const successTitle = t('SUCCESS_MODAL.TITLE');
  const buttonText = t('SUCCESS_MODAL.SUBMIT_BUTTON');
  const successContentText = t('SUCCESS_MODAL.SUCCESS.CONTENT');
  const errorTitle = t('ERROR_MODAL.TITLE');
  const errorContentText = t('ERROR_MODAL.CONTENT');
  const handleClose = () => {
    navigate(`/${VIEWS_MAP.DASHBOARD}`);
  };
  const handleRequestUpgrade = () => {
    postUploadSnapShot({
      fileUsageType: GENERIC_FILE_UPLOAD_TYPES.PLAN_UPGRADE_SUCCESS,
      imageName: `${Date.now()}`,
    });
    reportActOnLimitsIncreaseBottomSheet('Apply for Limit Increase');
    mutate({ customerId, accountExternalId, nextTier: teirData?.nextTier ?? 'XL' });
  };
  useEffect(() => {
    reportViewLimitsScreen(true);
  }, []);

  const handleOpenLimitsModal = () => {
    reportActOnLimitsScreen('Apply for Limit Increase');
    setOpenLimitsModal(true);
  };
  const handleCloseModal = () => {
    setOpenLimitsModal(false);
    reportActOnLimitsIncreaseBottomSheet('Not Now');
  };

  const handleCloseSucessModal = () => {
    setOpenSuccessModal(false);
  };
  useEffect(() => {
    if (isSuccess) {
      refetch();
      setOpenSuccessModal(true);
      setOpenLimitsModal(false);

      setModalType({ title: successTitle, content: successContentText, buttonText, success: true });
    } else if (isError) {
      setOpenSuccessModal(true);
      setModalType({ title: errorTitle, content: errorContentText, buttonText, success: false });
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    refetch();
  }, []);

  return {
    handleCloseModal,
    teirData,
    handleCloseSucessModal,
    handleOpenLimitsModal,
    handleRequestUpgrade,
    handleClose,
    openLimitsModal,
    openSuccessModal,
    requestLoading,
    customerId,
    accountExternalId,
    navigate,
    modalType,
  };
};
